import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private sidenavToggleSubject = new Subject<void>();
  sidenavToggle$ = this.sidenavToggleSubject.asObservable();

  constructor() { }

  toggle() {
    this.sidenavToggleSubject.next();
  }
}
